import { useAppDispatch } from 'src/hooks';
import { Grid, IconButton, Typography } from '@mui/material';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { toggleDrawerView, resetEanZrepDetails } from '../../store/planner-slice';
import { handleCloseEventOfDrawer } from './drawer-slice';

/**
 * Default header view of the drawer that is sticky at the top
 * with title (PPG or SKU) and a close button
 * click on the close button would reset the product mapping state in ean zrep table component
 */
export default function DrawerHeader({ title }: { title: string }) {
  const appDispatch = useAppDispatch();
  return (
    <Grid
      container
      sx={{
        position: 'sticky',
        top: 0,
        pt: 1.5,
        backgroundColor: '#FBFBFB',
        zIndex: 2
      }}
      justifyContent='space-between'
      alignItems='center'
      item
      xs={12}
    >
      <Typography fontSize='12px' color='#8080CF' fontWeight={700}>
        {title}
      </Typography>
      <IconButton
        aria-label='delete'
        size='medium'
        color='primary'
        onClick={() => {
          appDispatch(
            toggleDrawerView({
              view: null,
              productId: null,
              productKeyRef: ''
            })
          );
          appDispatch(handleCloseEventOfDrawer());
          appDispatch(resetEanZrepDetails());
        }}
      >
        <IoCloseCircleOutline />
      </IconButton>
    </Grid>
  );
}
